import * as FormFieldTypes from 'forms-utils-lib/fieldTypes/FormFieldTypes';
export const FieldTypes = {
  TEXT: 'text',
  CHECKBOX: 'checkbox',
  SINGLE_CHECKBOX: 'booleancheckbox',
  RADIO: 'radio',
  SELECT: 'select',
  DATE: 'date',
  TEXTAREA: 'textarea',
  NUMBER: 'number',
  FILE: 'file',
  PHONE: 'phone',
  PHONE_NUMBER: 'phonenumber',
  MOBILE_PHONE: 'mobilephone',
  SUBMIT: 'submit',
  PAYMENT_RADIO: 'payment_link_radio'
};
export const QuestionnaireFields = {
  MATRIX_RATING: 'matrixrating',
  STAR_RATING: 'starRating',
  RANGE: 'range',
  RATING: 'rating'
};
export const RichTextFields = {
  HEADER: 'header',
  PARAGRAPH: 'paragraph',
  IMAGE: 'image'
};
export const RichTextTypes = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE'
};
export const PageField = 'page';
export const TextType = {
  [FormFieldTypes.HEADER]: [FormFieldTypes.HEADER],
  [FormFieldTypes.PARAGRAPH]: [FormFieldTypes.PARAGRAPH]
};
export const ImageType = {
  [RichTextFields.IMAGE]: [RichTextFields.IMAGE]
};
export const RichTextFieldTypes = Object.assign({}, TextType, ImageType);
export const CreateNewFieldTypes = Object.assign({
  [FieldTypes.TEXT]: [FieldTypes.TEXT],
  [FieldTypes.NUMBER]: [FieldTypes.NUMBER],
  [FieldTypes.SINGLE_CHECKBOX]: [FieldTypes.SINGLE_CHECKBOX],
  [FieldTypes.CHECKBOX]: [FieldTypes.CHECKBOX],
  [FieldTypes.SELECT]: [FieldTypes.SELECT],
  [FieldTypes.TEXTAREA]: [FieldTypes.TEXTAREA],
  [FieldTypes.RADIO]: [FieldTypes.RADIO],
  [FieldTypes.DATE]: [FieldTypes.DATE],
  [FieldTypes.FILE]: [FieldTypes.FILE]
}, RichTextFieldTypes);
export const CreateNewFieldTypesPaginated = Object.assign({}, CreateNewFieldTypes, {
  page: 'page'
});
export const SpecialFieldTypes = {
  RICH_TEXT: 'richtext__hubspot_private',
  IMAGE: 'image_hubspot_private',
  CAPTCHA: 'captcha__hubspot_private',
  LEGAL_CONSENT: 'legal_consent_hubspot_private'
};
export const FieldTypeNames = Object.values(FieldTypes || {});
export const FeedbackFieldTypes = {
  EMAIL: 'email'
};
export const prependFields = Object.values(RichTextFields).reduce((accum, key) => {
  accum[key] = key;
  return accum;
}, {});
export const EmailField = 'email';
export const FirstNameField = 'firstname';
export const LastNameField = 'lastname';